import React, { createContext, useState, useEffect } from "react";
import { isLoggedInToday, clearBrowserCache, logout } from "./../../app/Utils/auth";

const AuthContext = React.createContext({});

function AuthProvider(props) {
  const [logado, setLogado] = useState(null);
  const [carregado, setCarregado] = useState(false);

  useEffect(() => {
    const status = isLoggedInToday();
    setLogado(status);
    setCarregado(true);

    // 🔒 checa expiração APENAS se estiver logado
    const interval = setInterval(() => {
      const aindaLogado = isLoggedInToday();
      if (logado && !aindaLogado) {
        clearBrowserCache();
        logout(); // força logout e limpeza total
        setLogado(false);
      }
    }, 60 * 1000); // 1 minuto

    return () => clearInterval(interval);
  }, [logado]);

  // escuta mudanças em outras abas
  useEffect(() => {
    const handler = () => setLogado(isLoggedInToday());
    window.addEventListener("storage", handler);
    return () => window.removeEventListener("storage", handler);
  }, []);

  // enquanto verifica sessão
  if (logado === null && !carregado) {
    return (
      <div style={{ textAlign: "center", marginTop: "20%", color: "#666" }}>
        Verificando sessão...
      </div>
    );
  }

  return (
    <AuthContext.Provider value={{ logado, setLogado }}>
      {props.children}
    </AuthContext.Provider>
  );
}

export { AuthContext, AuthProvider };
